import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { CHttp } from '../../core/services/chttp.service';
import { config } from '../../app.config';

enum Types {
  STAFF_INCENTIVE = 'Staff Incentive - Employment Stage Skipped',
  DISCOUNT = 'Discount - Employment Proof Required'
}

@Injectable()
export class MembershipCodeService {
  constructor(private http: CHttp) {}

  public getMembershipCodes(data?: any) {
    return this.http.get(config.api_url + 'promo-codes', { params: data });
  }

  public getMembershipCode(id: string) {
    return this.http.get(config.api_url + 'promo-codes/' + id);
  }

  public addMembershipCode(data: any) {
    return this.http.post(config.api_url + 'promo-codes', data);
  }

  public updateMembershipCode(data: any) {
    return this.http.put(config.api_url + 'promo-codes/' + data.id, data);
  }

  public deleteMembershipCode(id: string) {
    return this.http.delete(config.api_url + 'promo-codes/' + id);
  }

  public getTypeReadable(type) {
    return Types[type] || type;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/membership-code/services/membership-code.service.ts